import React, { Fragment } from 'react'
import { Division, RealEstateDataPageComponentData } from 'types'
import { Container } from 'react-bootstrap'
import { Link } from 'gatsby'
//@ts-ignore
import Background from './Section.jpg'

interface ExternalProps {
  divisions: Division[]
}

const PreHome_1 = ({
  title,
  image,
  global_data,
  divisions,
}: ExternalProps & RealEstateDataPageComponentData) => {
  const { logo, logoMobile } = global_data

  const getCurrentYear = () => new Date().getFullYear()
  return (
    <div className="preHome a">
      <nav>
        <Container fluid>
          <img
            src={logo}
            alt=""
            className="d-none d-lg-block"
          />
          <img
            src={logoMobile}
            alt=""
            className="d-block justify-content-center mx-auto d-lg-none"
          />
        </Container>
      </nav>
      <img
        src={image || Background}
        alt=""
        className="w-100 h-100 background-image position-absolute no-border"
      />
      {/* <Image
        className="w-100 h-100 background-image- position-absolute no-border "
        objectFit="cover"
        alt="about-us-img"
        image={image_gatsby!!}
        hrefImage={image!!}
      ></Image> */}
      {/* <h1>{title}</h1> */}
      <div className="d-flex flex-column">
        {title?.split('\n').map((line, index) => <h1 key={index}>{line}</h1>)}
      </div>
      <div className="bottom">
        <div className="nav-branches">
          {divisions.map(({ path, title }, index) => (
            <Fragment key={index}>
              {index ? <h5 className="v-line text-white mb-0"> | </h5> : ''}
              <Link
                to={path}
                className="text-decoration-none"
              >
                <h5 className="title-link text-center text-white text-uppercase px-5 mb-0">
                  {title}
                </h5>
              </Link>
            </Fragment>
          ))}
        </div>
        <div className="copy-footer mt-5 d-none d-lg-block">
          Promoted by{' '}
          <a
            target="_blank"
            href="https://mediahaus.com.ar"
          >
            MediaHaus
          </a>{' '}
          - Powered by{' '}
          <a
            target="_blank"
            href="https://mediacore.app/"
          >
            MediaCore
          </a>{' '}
          - Todos los derechos reservados ® {getCurrentYear()}
        </div>
      </div>
      <div className="copy-footer mt-5 d-block d-lg-none">
        Promoted by{' '}
        <a
          target="_blank"
          href="https://mediahaus.com.ar"
        >
          MediaHaus
        </a>{' '}
        - Powered by{' '}
        <a
          target="_blank"
          href="https://mediacore.app/"
        >
          MediaCore
        </a>{' '}
        <br /> Todos los derechos reservados ® {getCurrentYear()}
      </div>
    </div>
  )
}

export default PreHome_1
